<template lang='pug'>
//- Progress Bar
div(:class='$style[`cc-progress-bar`]')
  div(v-if='loadAnimate' :class='[$style[`cc-progress-bar-loader`], $style[`cc-load-animate`]]')
    div(:class='$style[`cc-progress-bar-loader-label`]')
  div(v-else :class='$style[`cc-progress-bar-loader`]')
    div(:class='$style[`cc-progress-bar-loader-label`]' :style='`width: ${currentPercent}%`')



</template>

<script>
// import { mapGetters } from 'vuex';

export default {
  props: {
    loadAnimate: {
      type: Boolean,
      default: false,
    },

    label: {
      type: Number,
      default: 0,
    },

    maxLabel: {
      type: Number,
      default: 0,
    },
  },

  // data() {
  //   return {
  //     showCookieAlert: true,
  //   };
  // },

  // methods: {
  // },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    currentPercent() {
      return (this.label / this.maxLabel) * 100;
    }
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/common/progressBar.scss';
</style>
